module.exports = __webpack_public_path__ + "static/img/game-logo-spade.e61de4b.png";


//////////////////
// WEBPACK FOOTER
// ./src/pages/build922/assets/image/gamelogo/game-logo-spade.png
// module id = Um4l
// module chunks = 0 1 2 3 4 5 6